import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAutoFlash: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="auto-flash"><path d="M20.25 8.75H13.25V2.5L3.75 15.25H10.75V21.5L20.25 8.75Z" stroke="currentColor" strokeWidth="1.5"/><path fillRule="evenodd" clipRule="evenodd" d="M23.1588 23.0001L21.36 14H20.33L14.918 23.0001H16.6803L17.8735 21.0001H21.234L21.6388 23.0001H23.1588ZM20.9339 19.5002H18.7734L20.3938 16.7996L20.9339 19.5002Z" fill="currentColor"/></CentralIconBase>;
};

export default IconAutoFlash;
